import { PerfAPIResponseSchema, type Period } from "@/types";
import dayjs from "dayjs";
import { SRP } from "hsl-core/providers";

export default function usePerfChartData(
	shareclassId?: number,
	partId?: number,
	startDate?: Date,
	endDate?: Date,
	period?: Period,
) {
	const formatDate = (d: Date) => dayjs(d).format("YYYY-MM-DD");
	const dateParams =
		startDate && endDate
			? {
					start_date: formatDate(startDate),
					end_date: formatDate(endDate),
				}
			: undefined;
	const periodParams =
		period && !dateParams ? { period_length: period } : undefined;
	const { data, isLoading } = SRP.useSRP(
		"/srp/api/perf-chart-part-new",
		!!partId && !!shareclassId,
		{
			shareclass: shareclassId,
			part_id: partId,
			...periodParams,
			...dateParams,
		},
	);

	if (!data || isLoading) {
		return [];
	}
	const validatedChartData = PerfAPIResponseSchema.safeParse(
		JSON.parse(data as string),
	);

	if (!validatedChartData.success) {
		console.error(validatedChartData.error);
		return [];
	}
	const shareClassName =
		validatedChartData.data.share_class_info.share_class_long_name;
	const shareClassLatestValue =
		validatedChartData.data.share_class_plots[0].data.at(-1)?.[1];
	const indices = validatedChartData.data.index_plots
		.filter((plot) => plot.data.length > 0)
		.map((plot) => plot.name);
	const indicesLatestValues = validatedChartData.data.index_plots
		.filter((plot) => plot.data.length > 0)
		.map((plot) => plot.data.at(-1)?.[1] ?? 0);

	return [
		validatedChartData.data,
		[shareClassName, ...indices] as string[],
		[shareClassLatestValue, ...indicesLatestValues] as number[],
	] as const;
}
